import gql from 'graphql-tag';

export default gql`
    query GetSandTicketExportStatus($exportId: ID!) {
        getSandTicketExportStatus(exportId: $exportId) {
            exportId
            status
            totalImages
            processedImages
            downloadUrl
            error
        }
    }
`;
